export default {
  PRODUCT_CATEGORIES: [
    'Bonuses',
    'Corrections',
    'DealerAccessories',
    'DeliveryCosts',
    'NonRecoverableCosts',
    'Taxes',
  ],
  CORRECTION_CATEGORY_CODE: 'OO',
  VAT_RATES: [
    {
      vatName: 'BTW Hoog',
      vatValue: '21',
    },
    {
      vatName: 'BTW Laag',
      vatValue: '9',
    },
    {
      vatName: 'Geen BTW',
      vatValue: '0',
    },
  ],
  PRIVATE_LEASE_OWN_RISK_LEVELS: [
    {
      name: '125',
      value: '400297',
    },
    {
      name: '250',
      value: '400300',
    },
    {
      name: '500',
      value: '400301',
    },
  ],
  OPERATIONAL_LEASE_OWN_RISK_LEVELS: [
    {
      name: '135',
      value: 'C135',
    },
    {
      name: '250',
      value: 'C250',
    },
    {
      name: '500',
      value: 'C500',
    },
  ],
  leaseTypes: {
    PRIVATE_LEASE: 'privateLease',
    OPERATIONAL_LEASE: 'operationalLease',
  },
}
